import { Typography } from '@mui/material';
import styles from './SupportAccordion.module.scss';
import { FaqAccordion } from '../../../faq/faq';

const SupportAccordion = ({ accordionTitle = '', accordionItems = [] }) => {
  return (
    <>
      <div className={styles.accordionExtender}>
        <div className={styles.container}>
          <div className={styles.subContainer}>
            <Typography variant="h2" color="primary.main">
              {accordionTitle}
            </Typography>
            <div>
              <FaqAccordion
                items={accordionItems}
                itemTitle={'question'}
                itemContent={'answer'}
                gutterDisable={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SupportAccordion;
